import { render } from "./AttentionModal.vue?vue&type=template&id=7d338268&scoped=true&ts=true&lang=pug"
import script from "./AttentionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttentionModal.vue?vue&type=script&setup=true&lang=ts"

import "./AttentionModal.vue?vue&type=style&index=0&id=7d338268&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d338268"]])

export default __exports__